import { render, staticRenderFns } from "./work-message-legal.vue?vue&type=template&id=839eb7e6&scoped=true"
import script from "./work-message-legal.vue?vue&type=script&lang=ts"
export * from "./work-message-legal.vue?vue&type=script&lang=ts"
import style0 from "./work-message-legal.vue?vue&type=style&index=0&id=839eb7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839eb7e6",
  null
  
)

export default component.exports